(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll("[data-cyabags-nav-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        var selector = button.getAttribute("data-cyabags-nav-toggle");
        var container = button.closest(".cyabags-nav");
        var nav = container ? container.querySelector(selector) : document.querySelector(selector);
        if (!nav) return;
        var isOpen = nav.classList.toggle("show");
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });

    initMobileStickyHeader();

    document.querySelectorAll("[data-cyabags-countdown]").forEach(function (timerEl) {
      var minutes = parseInt(timerEl.getAttribute("data-duration-minutes") || "15", 10);
      var endTime = Date.now() + Math.max(1, minutes) * 60 * 1000;
      var pad = function (value) { return value < 10 ? "0" + value : String(value); };
      var render = function () {
        var totalSeconds = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        var hours = Math.floor(totalSeconds / 3600);
        var mins = Math.floor((totalSeconds % 3600) / 60);
        var secs = totalSeconds % 60;
        timerEl.textContent = pad(hours) + ":" + pad(mins) + ":" + pad(secs);
        if (totalSeconds <= 0) window.clearInterval(interval);
      };
      var interval = window.setInterval(render, 1000);
      render();
    });

    document.querySelectorAll(".cyabags-native a[href^='#']").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        var nav = link.closest(".cyabags-nav");
        if (nav) {
          var menu = nav.querySelector(".cyabags-nav__links.show");
          var toggle = nav.querySelector("[data-cyabags-nav-toggle]");
          if (menu) menu.classList.remove("show");
          if (toggle) toggle.setAttribute("aria-expanded", "false");
        }
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    document.querySelectorAll("[data-cyabags-faq-question]").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".cyabags-faq__item");
        var list = button.closest(".cyabags-faq__list");
        var answer = item ? item.querySelector(".cyabags-faq__answer") : null;
        if (!item) return;
        var willOpen = !item.classList.contains("active");
        if (list) {
          list.querySelectorAll(".cyabags-faq__item.active").forEach(function (active) {
            if (active !== item) {
              var activeAnswer = active.querySelector(".cyabags-faq__answer");
              active.classList.remove("active");
              if (activeAnswer) activeAnswer.style.maxHeight = "0px";
            }
          });
        }
        item.classList.toggle("active", willOpen);
        if (answer) answer.style.maxHeight = willOpen ? answer.scrollHeight + "px" : "0px";
      });
    });

    document.querySelectorAll("[data-cyabags-carousel]").forEach(function (controls) {
      var grid = document.querySelector(controls.getAttribute("data-cyabags-carousel"));
      if (!grid) return;
      var cards = grid.querySelectorAll(".cyabags-video-card");
      var dots = controls.querySelectorAll(".cyabags-carousel-dot");
      var prev = controls.querySelector(".cyabags-carousel-arrow--prev");
      var next = controls.querySelector(".cyabags-carousel-arrow--next");
      if (!cards.length) return;

      function activeIndexFromScroll() {
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var nextDistance = Math.abs(card.offsetLeft - grid.scrollLeft);
          if (nextDistance < distance) {
            nearest = index;
            distance = nextDistance;
          }
        });
        return nearest;
      }

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle("active", dotIndex === index);
        });
      }

      function scrollToIndex(index) {
        var clamped = Math.max(0, Math.min(index, cards.length - 1));
        grid.scrollTo({ left: cards[clamped].offsetLeft, behavior: "smooth" });
        setActive(clamped);
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () { scrollToIndex(index); });
      });
      if (prev) prev.addEventListener("click", function () { scrollToIndex(activeIndexFromScroll() - 1); });
      if (next) next.addEventListener("click", function () { scrollToIndex(activeIndexFromScroll() + 1); });
      grid.addEventListener("scroll", function () {
        window.clearTimeout(grid.cyabagsScrollTimer);
        grid.cyabagsScrollTimer = window.setTimeout(function () { setActive(activeIndexFromScroll()); }, 50);
      });
    });

    initVidalytics();
  });

  function initMobileStickyHeader() {
    var header = document.querySelector("[data-cyabags-mobile-sticky-header]");
    var wrap = document.querySelector("[data-cyabags-mobile-sticky-wrap]");
    var hero = document.querySelector(".cyabags-hero");
    if (!header || !wrap || !hero) return;

    var mobileQuery = window.matchMedia("(max-width: 768px)");
    var ticking = false;

    function reset() {
      header.classList.remove("cyabags-header--stuck");
      wrap.style.removeProperty("--cyabags-mobile-header-height");
    }

    function update() {
      ticking = false;
      if (!mobileQuery.matches) {
        reset();
        return;
      }

      var headerHeight = header.offsetHeight;
      wrap.style.setProperty("--cyabags-mobile-header-height", headerHeight + "px");
      header.classList.toggle("cyabags-header--stuck", hero.getBoundingClientRect().bottom > headerHeight);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", requestUpdate);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(requestUpdate);
    }
  }

  function initVidalytics() {
    var targets = document.querySelectorAll("[data-cyabags-vidalytics-id]");
    if (!targets.length) return;
    var loaded = {};

    function mount(target) {
      var videoId = target.getAttribute("data-cyabags-vidalytics-id");
      var embedBase = target.getAttribute("data-cyabags-embed-base") || "https://quick.vidalytics.com/embeds/hLKq71Yz/";
      if (!videoId || loaded[videoId]) return;
      loaded[videoId] = true;
      target.id = videoId;
      target.style.width = "100%";
      target.style.position = "relative";
      target.style.paddingTop = "56.25%";

      (function (v, i, d, a, l, y, t, c, s) {
        y = "_" + d.toLowerCase();
        c = d + "L";
        if (!v[d]) v[d] = {};
        if (!v[c]) v[c] = {};
        if (!v[y]) v[y] = {};
        var vl = "Loader";
        var vli = v[y][vl];
        var vsl = v[c][vl + "Script"];
        var vlf = v[c][vl + "Loaded"];
        var ve = "Embed";
        if (!vsl) {
          vsl = function (u, cb) {
            if (t) { cb(); return; }
            s = i.createElement("script");
            s.type = "text/javascript";
            s.async = 1;
            s.src = u;
            s.onload = function () { vlf = 1; cb(); };
            i.getElementsByTagName("head")[0].appendChild(s);
          };
        }
        vsl(l + "loader.min.js", function () {
          if (!vli) {
            var vlc = v[c][vl];
            vli = new vlc();
          }
          vli.loadScript(l + "player.min.js", function () {
            var vec = v[d][ve];
            t = new vec();
            t.run(a);
          });
        });
      })(window, document, "Vidalytics", videoId, embedBase + videoId + "/");
    }

    if (!("IntersectionObserver" in window)) {
      targets.forEach(mount);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        mount(entry.target);
      });
    }, { rootMargin: "450px 0px" });

    targets.forEach(function (target) { observer.observe(target); });
  }
})();
